import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-table',
    templateUrl: './product-table.component.html',
    styleUrls: ['./product-table.component.scss'],
    standalone: false
})
export class ProductTableComponent extends FieldArrayType {}
